import React from 'react'
import EmployeeDelete from "./EmployeeDelete";
import EmployeeEdit from "./EmployeeEdit";
import EmployeeRole from "./EmployeeRole";
import EmployeeCustomer from "./EmployeeCustomer";
import EmployeeBrand from "./EmployeeBrand";

const EmployeeActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <EmployeeEdit employee={record} updater={updater} />
            <EmployeeCustomer employeeId={record.id} />
            <EmployeeBrand employeeId={record.id}/>
            <EmployeeRole employeeId={record.id} updater={updater}/>
            <EmployeeDelete employeeId={record.id} updater={updater} />
        </React.Fragment>
    )
}
export default EmployeeActions